<template>
  <v-container>
    <v-layout column wrap>
      <v-carousel>
        <v-carousel-item
          v-for="browse in pics"
          :src="browse.imageUrl"
          :key="browse.id">
        </v-carousel-item>
      </v-carousel>
    </v-layout>
    <v-layout column wrap>
      <v-flex xs12 sm6 class="text-sm-center">
        <v-btn large
        router to="/browse"
        dark class="yellow darken-4">
         Start Exploring
       </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        pics: [
          { imageUrl: 'https://www.utdallas.edu/news/imgs/bsb-dedication-2016/1-bsb-dedication.jpg', id:'pic1',title:'BSB building'},
          { imageUrl: 'https://engineering.utdallas.edu/engineering/files/facilities-MaterialScienceandEngineering.jpg', id:'pic2',title:'NSRL building'}
        ],
        user: '',
        role: ''
      }
    }
  }
</script>
